import { render, staticRenderFns } from "./asset_management.vue?vue&type=template&id=14f9960e&scoped=true"
import script from "./asset_management.vue?vue&type=script&lang=js"
export * from "./asset_management.vue?vue&type=script&lang=js"
import style0 from "./asset_management.vue?vue&type=style&index=0&id=14f9960e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f9960e",
  null
  
)

export default component.exports